export const supportThemList = [
  {
    id: 2,
    title: 'Запись видеорезюме',
  },
  {
    id: 3,
    title: 'Запись видеовакансии',
  },
  {
    id: 4,
    title: 'Регистрация компании',
  },
  {
    id: 5,
    title: 'Сообщить о неисправности',
  },
  {
    id: 6,
    title: 'Идеи и доработки',
  },
  {
    id: 1,
    title: 'Другие вопросы',
  },
];